"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = require("../../shared/resource");
var NotificationsReport = /** @class */ (function (_super) {
    __extends(NotificationsReport, _super);
    function NotificationsReport() {
        var _this = _super.call(this) || this;
        _this.textColor = 'rgba(0, 0, 0, .87)';
        return _this;
    }
    return NotificationsReport;
}(resource_1.Resource));
exports.NotificationsReport = NotificationsReport;
